import { render, staticRenderFns } from "./add-Merchant.vue?vue&type=template&id=7d2d73fd&scoped=true&"
import script from "./add-Merchant.vue?vue&type=script&lang=js&"
export * from "./add-Merchant.vue?vue&type=script&lang=js&"
import style0 from "./add-Merchant.vue?vue&type=style&index=0&id=7d2d73fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d2d73fd",
  null
  
)

export default component.exports